// Make menu styles (by category scopes)
function makeMenuColors (categoryScopes) {
  let styles = {};
  for (let scope in categoryScopes) {
    styles = {
      ...styles,
      [`style_${scope}`]: {
        '&:hover, &.active': {
          backgroundColor: categoryScopes[scope].primary[50],
          color: [categoryScopes[scope].primary[500], '!important'],
        },
        borderBottomColor: categoryScopes[scope].primary[500]
      },
    }
  }
  return styles;
}

export default theme => {
  const categoryScopeStyles = makeMenuColors(theme.palette.categoryScopes);
  let styles = {
    menu: {
      display: 'flex',
      width: '100%',
      // maxWidth: 700,
      [theme.breakpoints.up(960)]: {
        maxWidth: 550
      },
      [theme.breakpoints.up(1000)]: {
        maxWidth: 600
      },
      [theme.breakpoints.up(1025)]: {
        maxWidth: 'initial'
      },
      // [theme.breakpoints.between(960, 1023)]: {
      //   maxWidth: 550
      // },
    },
    list: {
    },
    tabs: {
      minHeight: 'auto',
    },
    tabsScroller: {
      overflow: 'hidden'
    },
    tabsContainer: {
      height: 44,
      position: 'relative'
    },
    scrollButtonsAuto: {
      width: 'auto',
      // display: 'none',
    },
    item: {
      display: 'inline-block',
      minWidth: 'auto',
      minHeight: 'auto',

      color: '#616263',
      // height: '43px',
      fontSize: '14px',
      fontWeight: 'normal',
      padding: '0 13px',
      margin: '0 1px',
      lineHeight: '42px',
      borderBottomWidth: 3,
      borderBottomStyle: 'solid',
      '-moz-transition': 'background-color .3s',
      '-o-transition': 'background-color .3s',
      '-webkit-transition': 'background-color .3s',
      transition: 'background-color .3'
    },
    itemLabelContainer: {
      width: '100%',
      // padding: '6px 5px',
      padding: 0,
      boxSizing: 'border-box',      
    },
    // @media (min-width:960px) {
    //   .MuiTab-labelContainer-znaxyq {
    //     padding: 6px 24px;
    //   }
    menuButton: {
      marginLeft: -12,
      marginRight: 20,
    },
  };

  styles = {...styles, ...categoryScopeStyles};
  // console.log(styles)

  return styles;
}